import { useModal } from "hooks";
import useFile, { IViewAndDownloadProps } from "hooks/useFile";
import { createContext } from "react";

export interface IThirdPartyAdministrationContext {
  handleViewFile: (props: IViewAndDownloadProps) => void
}

export const ThirdPartyAdministrationContext = createContext<IThirdPartyAdministrationContext>({} as IThirdPartyAdministrationContext)


export const ThirdPartyAdministrationProvider = ({ children }) => {

  const { showModal } = useModal()
  const { viewFile } = useFile()

  const handleViewFile = (props: IViewAndDownloadProps) => {
    if ( props.gedExternalID == '') {
      showModal({
        hideButtonCancel: true,
        message: 'O documento que você esta tentando visualizar é anterior ao PORTAL NGT (28/12/2022). Você só terá visualização da documentação postada após a implantação do sistema.',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })

      return
    }

    viewFile(props)
  }
  return (
    <ThirdPartyAdministrationContext.Provider value={{ handleViewFile }}>
      {children}
    </ThirdPartyAdministrationContext.Provider>
  )
}
